import React from 'react';

export const DesktopIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="210" height="200" viewBox="0 0 210 200" fill="#A1ACB3" {...props}>
    <path
      d="M150 55.5H60C55.8516 55.5 52.5 58.8516 52.5 63V123H45V63C45 54.7266 51.7266 48 60 48H150C158.273 48 165 54.7266 165 63V123H157.5V63C157.5 58.8516 154.148 55.5 150 55.5ZM48 145.5H162C166.758 145.5 170.766 142.336 172.055 138H37.9453C39.2344 142.336 43.2656 145.5 48 145.5ZM30 135C30 132.516 32.0156 130.5 34.5 130.5H175.5C177.984 130.5 180 132.516 180 135C180 144.938 171.938 153 162 153H48C38.0625 153 30 144.938 30 135Z"
    />
  </svg>
);
